import React from 'react';
import { Link } from 'react-router-dom';

/*
  Informativa privacy e cookie.

  Descrive quello che il sito e l'area riservata fanno davvero: nessun
  analytics, nessun cookie di profilazione, e i servizi esterni che vedono dei
  dati (notifiche push, email, WhatsApp, chiamate vocali, geocodifica degli
  indirizzi). Va tenuta allineata al codice: se un domani si aggiunge uno
  strumento di misurazione, questa pagina cambia insieme a lui e in quel caso
  serve anche il consenso, non basta più la fascia cookie.
*/

const AGGIORNAMENTO = '11 settembre 2026';

export const DATI_AZIENDA = {
  ragioneSociale: 'Ciesse Impianti SRL',
  indirizzo: 'Via Montelatrone 3',
  comune: '06059 Todi (PG)',
  partitaIva: '03983230545',
  email: 'assistenza@ciesseimpiantisrl.it',
  telefono: '+39 393 9144234',
  telefonoHref: 'tel:+393939144234',
};

const sezioni = [
  {
    titolo: 'Titolare del trattamento',
    paragrafi: [
      `${DATI_AZIENDA.ragioneSociale}, ${DATI_AZIENDA.indirizzo} — ${DATI_AZIENDA.comune}. Partita IVA ${DATI_AZIENDA.partitaIva}.`,
      `Per qualsiasi richiesta relativa ai tuoi dati scrivi a ${DATI_AZIENDA.email} oppure chiama il ${DATI_AZIENDA.telefono}.`,
    ],
  },
  {
    titolo: 'Cookie e archiviazione locale',
    paragrafi: [
      'Su questo sito non ci sono cookie di profilazione, strumenti di analisi statistica, pixel pubblicitari o contenuti incorporati da terze parti. Le immagini e i loghi sono serviti dai nostri server.',
      'Quello che viene salvato sul tuo dispositivo è tecnico, serve al funzionamento e resta sul dispositivo:',
    ],
    voci: [
      {
        titolo: "Sessione dell'area riservata",
        testo:
          "Dopo il login il browser conserva il token di accesso, il ruolo e l'immagine del profilo, così non devi rifare l'accesso a ogni pagina. Si cancellano uscendo dall'account.",
      },
      {
        titolo: 'Preferenze di lettura e di interfaccia',
        testo:
          'Una voce ricorda che hai già letto questa informativa, per non riproporti la fascia a ogni visita. Un\'altra ricorda su quale lato dello schermo hai spostato il pulsante WhatsApp.',
      },
      {
        titolo: 'Funzionamento offline (PWA)',
        testo:
          'Se aggiungi Ciesse alla schermata Home, il service worker tiene in cache le pagine, le immagini e i modelli dei verbali per far funzionare l\'applicazione anche con rete lenta o assente. I rapportini compilati senza rete restano in una coda locale sul dispositivo finché non vengono spediti.',
      },
      {
        titolo: 'Notifiche push',
        testo:
          'Solo se attivi tu le notifiche, Firebase Cloud Messaging (Google) registra un identificativo del dispositivo, necessario a recapitare gli avvisi. Si disattiva dalle impostazioni e l\'identificativo viene rimosso.',
      },
    ],
  },
  {
    titolo: 'Dati trattati e finalità',
    voci: [
      {
        titolo: "Dati dell'account",
        testo:
          "Nome, cognome, indirizzo email, telefono e ruolo servono a creare l'accesso, recuperare la password e recapitare gli avvisi operativi.",
      },
      {
        titolo: 'Dati dei clienti e degli impianti',
        testo:
          'Anagrafica del cliente, sedi, macchine installate, interventi, verbali di manutenzione e certificazioni sono i dati per cui il servizio esiste: servono a pianificare, documentare e ricostruire il lavoro svolto.',
      },
      {
        titolo: 'Dati di monitoraggio',
        testo:
          'Per gli impianti collegati ai dispositivi Clotho vengono conservati temperature, stato dei dispositivi, soglie e allarmi, per il monitoraggio, lo storico e la tracciabilità delle anomalie.',
      },
      {
        titolo: 'Richieste di contatto e assistenza',
        testo:
          'Il contenuto delle richieste inviate per email, telefono o WhatsApp, con eventuali allegati, viene conservato per gestire la richiesta e ricostruire l\'intervento.',
      },
      {
        titolo: 'Registro delle attività',
        testo:
          'Alcune operazioni sugli account, sui documenti e sugli aggiornamenti dei dispositivi vengono registrate (chi, quando, cosa) per sicurezza e per obblighi di tracciabilità.',
      },
    ],
  },
  {
    titolo: 'Base giuridica e conservazione',
    paragrafi: [
      'I dati dell\'account, dei clienti e degli impianti sono trattati per eseguire il contratto di assistenza o di fornitura del servizio; le richieste di contatto per rispondere a chi ci scrive; i registri di sicurezza e i dati di fatturazione per adempiere a obblighi di legge.',
      'I dati restano per il tempo del rapporto contrattuale. Dopo la chiusura si conservano solo quelli che la legge impone di tenere, in primo luogo i documenti fiscali e i verbali di manutenzione per dieci anni, mentre gli altri vengono cancellati o resi anonimi.',
    ],
  },
  {
    titolo: 'A chi vengono comunicati',
    paragrafi: [
      'I dati non vengono venduti né ceduti per finalità pubblicitarie. Sono trattati da fornitori che agiscono per nostro conto, ciascuno limitatamente a quello che serve:',
    ],
    voci: [
      {
        titolo: 'Clotho S.r.l.',
        testo:
          'Partner tecnologico per i dispositivi di monitoraggio: riceve i dati di telemetria degli impianti collegati ai suoi sensori.',
      },
      {
        titolo: 'Google (Firebase Cloud Messaging)',
        testo: 'Recapito delle notifiche push, solo per chi le ha attivate.',
      },
      {
        titolo: 'Provider di posta elettronica',
        testo: 'Invio delle email di servizio: recupero password e avvisi operativi.',
      },
      {
        titolo: 'Meta (WhatsApp Business)',
        testo:
          'Se ci scrivi su WhatsApp, i messaggi passano dalla piattaforma di Meta secondo la sua informativa. Le prime risposte automatiche sono generate da un assistente basato su OpenAI, a cui viene inviato il testo della conversazione per formulare la risposta; le richieste vengono poi prese in carico da un operatore.',
      },
      {
        titolo: 'Twilio',
        testo:
          'Chiamate vocali automatiche di avviso in caso di allarme, verso i numeri di telefono dei referenti che le hanno richieste.',
      },
      {
        titolo: 'OpenStreetMap (Nominatim)',
        testo:
          'Geocodifica degli indirizzi delle sedi di intervento e mappe di sfondo, usate nell\'area riservata per pianificare gli spostamenti dei tecnici.',
      },
    ],
  },
  {
    titolo: 'I tuoi diritti',
    paragrafi: [
      `Puoi chiedere l'accesso ai tuoi dati, la rettifica, la cancellazione, la limitazione del trattamento, l'opposizione e la portabilità (artt. 15-22 del Regolamento UE 2016/679). Basta scrivere a ${DATI_AZIENDA.email}: rispondiamo entro trenta giorni.`,
      'Se ritieni che il trattamento violi il Regolamento puoi rivolgerti al Garante per la protezione dei dati personali.',
    ],
  },
  {
    titolo: 'Aggiornamenti',
    paragrafi: [
      `Questa informativa descrive il sito e l'area riservata come funzionano oggi. Se cambieranno gli strumenti usati, per esempio con l'introduzione di misurazioni statistiche, la pagina verrà aggiornata e, dove serve il consenso, ti verrà chiesto prima di attivarli. Ultimo aggiornamento: ${AGGIORNAMENTO}.`,
    ],
  },
];

export default function Privacy() {
  return (
    <main className="min-h-screen bg-white px-6 py-16 text-slate-900">
      <div className="mx-auto max-w-3xl">
        <Link
          to="/"
          className="inline-flex rounded-xl border border-slate-200 bg-slate-50 px-4 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-100"
        >
          ← Torna alla home
        </Link>

        <p className="mt-10 text-sm font-semibold uppercase tracking-[0.2em] text-blue-600">
          Trasparenza
        </p>

        <h1 className="mt-3 text-4xl font-bold leading-tight tracking-tight text-slate-950 md:text-5xl">
          Informativa privacy e cookie
        </h1>

        <p className="mt-5 text-lg leading-8 text-slate-600">
          Cosa salviamo, perché, per quanto e a chi lo comunichiamo. In breve:
          nessuna profilazione, nessun tracciamento pubblicitario, solo i dati
          che servono a gestire gli interventi e il monitoraggio.
        </p>

        <div className="mt-12 space-y-6">
          {sezioni.map((sezione) => (
            <section
              key={sezione.titolo}
              className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm md:p-8"
            >
              <h2 className="text-2xl font-bold text-slate-950">{sezione.titolo}</h2>

              {sezione.paragrafi?.map((testo) => (
                <p key={testo} className="mt-4 leading-7 text-slate-600">
                  {testo}
                </p>
              ))}

              {sezione.voci && (
                <ul className="mt-5 space-y-4">
                  {sezione.voci.map((voce) => (
                    <li
                      key={voce.titolo}
                      className="rounded-2xl border border-slate-200 bg-slate-50 p-4"
                    >
                      <p className="font-semibold text-slate-900">{voce.titolo}</p>
                      <p className="mt-1 text-sm leading-6 text-slate-600">{voce.testo}</p>
                    </li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
